import React from "react";
import { Link } from "react-router-dom";
import i18n from "../../i18n";
import { baseUrl } from "../../constants/global";
import swal from "sweetalert";
import Dropdown from "react-bootstrap/Dropdown";
import contryData from "../../constants/country.json";
import registerUser from "../../models/register";

const codeData = [...contryData];

export class NewRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            input: {
                country_code: "+966",
                name: "",
                email: "",
                username: "",
                mobile: "",
                password: "",
                password_confirmation: ""
            },
            is_company: false,
            selected_country: this.getObjectByKeyValue(codeData, "dial_code", "+966"),
            t_c_acept: false,
            errors: {},
            isLoading: false,
            showPassword: false,
            showConfirmPassword: false
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    getObjectByKeyValue(jsonArray, key, value) {
        for (var i = 0; i < jsonArray.length; i++) {
            if (jsonArray[i][key] === value) {
                return jsonArray[i];
            }
        }
        return null;
    }

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            this.setState({
                [name]: checked,
                errors: { ...this.state.errors, [name]: '' }
            });
        } else {
            let input = { ...this.state.input };
            input[name] = value;
            this.setState({
                input,
                errors: { ...this.state.errors, [name]: '' }
            });
        }
    };

    handleChange = (event) => {
        let input = { ...this.state.input };
        input[event.target.name] = event.target.value;
        this.setState({ input });
    };

    validatePassword(password) {
        const errors = [];
        
        if (password.length < 8) {
            errors.push(i18n.t("password_min_length"));
        }
        
        if (!/(?=.*[a-z])/.test(password)) {
            errors.push(i18n.t("password_lowercase"));
        }
        
        if (!/(?=.*[A-Z])/.test(password)) {
            errors.push(i18n.t("password_uppercase"));
        }
        
        if (!/(?=.*\d)/.test(password)) {
            errors.push(i18n.t("password_number"));
        }
        
        if (!/(?=.*[@$!%*?&])/.test(password)) {
            errors.push(i18n.t("password_special_char"));
        }
        
        return errors;
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["name"]) {
            isValid = false;
            errors["name"] = i18n.t("validate_name");
        }

        if (!input["username"]) {
            isValid = false;
            errors["username"] = i18n.t("validate_username");
        }

        if (!input["country_code"]) {
            isValid = false;
            errors["country_code"] = i18n.t("validate_country_code");
        }

        if (!input["mobile"]) {
            isValid = false;
            errors["mobile"] = i18n.t("validate_phone");
        }

        var pattern = new RegExp(
            /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );

        if (!input["email"] || !pattern.test(input["email"])) {
            isValid = false;
            errors["email"] = i18n.t("validate_email");
        }

        // Password validation
        if (!input["password"]) {
            isValid = false;
            errors["password"] = i18n.t("validate_password");
        } else {
            const passwordErrors = this.validatePassword(input["password"]);
            if (passwordErrors.length > 0) {
                isValid = false;
                errors["password"] = passwordErrors;
            }
        }

        if (!input["password_confirmation"]) {
            isValid = false;
            errors["password_confirmation"] = i18n.t("validate_confirm_pass");
        }

        if (input["password"] !== input["password_confirmation"]) {
            isValid = false;
            errors["password_confirmation"] = i18n.t("validate_password_match");
        }

        this.setState({ errors: errors });
        return isValid;
    }

    togglePasswordVisibility = () => {
        this.setState(prevState => ({
            showPassword: !prevState.showPassword
        }));
    };

    toggleConfirmPasswordVisibility = () => {
        this.setState(prevState => ({
            showConfirmPassword: !prevState.showConfirmPassword
        }));
    };

    handleSubmit = async (event) => {
        event.preventDefault();

        if (!this.validate()) return;

        this.setState({ isLoading: true });

        try {
            const formData = new FormData();
            formData.append("name", this.state.input.name);
            formData.append("country_code", this.state.input.country_code);
            formData.append("mobile", this.state.input.mobile);
            formData.append("email", this.state.input.email);
            formData.append("username", this.state.input.username);
            formData.append("password", this.state.input.password);
            formData.append("password_confirmation", this.state.input.password_confirmation);

            const response = await registerUser(formData);

            if (response.success) {
                swal(i18n.t("success"), "Registration completed successfully!!", "success", {
                    buttons: false,
                    timer: 2000,
                }).then((value) => {
                    this.resetForm();
                    window.location.href = "/login";
                });
            } else {
                let error_message = response.message;
                let resObject = response.data;

                for (const key in resObject) {
                    if (Object.hasOwnProperty.call(resObject, key)) {
                        let element = resObject[key];
                        error_message += "\n" + element;
                    }
                }

                swal("Failed", error_message, "error");
            }
        } catch (err) {
            console.log(err);
            swal("Failed", "Registration failed. Please try again.", "error");
        } finally {
            this.setState({ isLoading: false });
        }
    };

    resetForm() {
        let input = {};
        input["name"] = "";
        input["mobile"] = "";
        input["email"] = "";
        input["username"] = "";
        input["country_code"] = "+966";
        input["password"] = "";
        input["password_confirmation"] = "";
    }

    render() {
        const { input, errors, isLoading, is_company, t_c_acept, selected_country, showPassword, showConfirmPassword } = this.state;
        let selected_img = selected_country && selected_country.code ? selected_country.code.toLowerCase() : "";

        return (
            <div className="vh-100 d-flex">
                {/* Left Side - Registration Form */}
                <div className="col-lg-6 d-flex align-items-center justify-content-center bg-white overflow-auto py-4">
                    <div className="w-100" style={{ maxWidth: '650px', padding: '2rem' }}>
                        {/* Welcome Header */}
                        <div className="mb-4">
                            <h2 className="fw-bold text-dark mb-2" style={{ fontSize: '2rem' }}>
                                {i18n.t("registration")}
                            </h2>
                        </div>

                        {/* Registration Form */}
                        <form onSubmit={this.handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label text-dark fw-medium mb-1">
                                        <span className="text-danger">*</span> {i18n.t("name")}
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={input.name}
                                        onChange={this.handleInputChange}
                                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                        style={{ padding: '12px 16px', fontSize: '14px', borderRadius: '8px' }}
                                        placeholder={i18n.t("enter_your_name")}
                                    />
                                    {errors.name && <div className="text-danger small mt-1">{errors.name}</div>}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label text-dark fw-medium mb-1">
                                        <span className="text-danger">*</span> {i18n.t("email")}
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={input.email}
                                        onChange={this.handleInputChange}
                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                        style={{ padding: '12px 16px', fontSize: '14px', borderRadius: '8px' }}
                                        placeholder={i18n.t("enter_your_email")}
                                    />
                                    {errors.email && <div className="text-danger small mt-1">{errors.email}</div>}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label text-dark fw-medium mb-1">
                                        <span className="text-danger">*</span> {i18n.t("username")}
                                    </label>
                                    <input
                                        type="text"
                                        name="username"
                                        value={input.username}
                                        onChange={this.handleInputChange}
                                        className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                                        style={{ padding: '12px 16px', fontSize: '14px', borderRadius: '8px' }}
                                        placeholder={i18n.t("please_enter_username")}
                                    />
                                    {errors.username && <div className="text-danger small mt-1">{errors.username}</div>}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label text-dark fw-medium mb-1">
                                        <span className="text-danger">*</span> {i18n.t("phone_number")}
                                    </label>
                                    <div className="d-flex">
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="light"
                                                className="d-flex align-items-center"
                                                style={{
                                                    border: "1px solid #ddd",
                                                    borderRadius: "8px 0 0 8px",
                                                    padding: "12px 10px",
                                                    background: "#fff",
                                                    minWidth: "90px",
                                                }}
                                            >
                                                {selected_country && (
                                                    <>
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/images/flags/" + selected_img + ".svg"}
                                                            alt="flag"
                                                            style={{ width: "20px", marginRight: "6px" }}
                                                        />
                                                        {selected_country.dial_code}
                                                    </>
                                                )}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto", minWidth: "200px" }}>
                                                {codeData.map((item, i) => {
                                                    let img = item.code.toLowerCase();
                                                    return (
                                                        <Dropdown.Item
                                                            key={i}
                                                            onClick={() => {
                                                                let input = { ...this.state.input };
                                                                input.country_code = item.dial_code;
                                                                this.setState({
                                                                    input,
                                                                    selected_country: item,
                                                                });
                                                            }}
                                                            className="d-flex align-items-center"
                                                        >
                                                            <img
                                                                src={process.env.PUBLIC_URL + "/images/flags/" + img + ".svg"}
                                                                alt="flag"
                                                                style={{ width: "20px", marginRight: "8px" }}
                                                            />
                                                            {item.label} ({item.dial_code})
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <input
                                            type="text"
                                            name="mobile"
                                            value={input.mobile}
                                            onChange={this.handleInputChange}
                                            className={`form-control ${errors.mobile ? 'is-invalid' : ''}`}
                                            style={{ borderRadius: "0 8px 8px 0", padding: '12px 16px', fontSize: '14px' }}
                                            placeholder={i18n.t("phone_number")}
                                        />
                                    </div>
                                    {errors.mobile && <div className="text-danger small mt-1">{errors.mobile}</div>}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label text-dark fw-medium mb-1">
                                        <span className="text-danger">*</span> {i18n.t("password")}
                                    </label>
                                    <div className="position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            value={input.password}
                                            onChange={this.handleInputChange}
                                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                            style={{ 
                                                padding: '12px 16px', 
                                                fontSize: '14px', 
                                                borderRadius: '8px',
                                                paddingRight: '45px'
                                            }}
                                            placeholder={i18n.t("please_enter_password")}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                            style={{
                                                border: 'none',
                                                background: 'transparent',
                                                padding: '12px 12px',
                                                zIndex: 5
                                            }}
                                            onClick={this.togglePasswordVisibility}
                                        >
                                            <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                        </button>
                                    </div>
                                    {errors.password && (
                                        <div className="mt-2">
                                            {Array.isArray(errors.password) ? (
                                                <div className="small">
                                                    <div className="text-danger fw-medium mb-1">
                                                        {i18n.t("password_requirements")}:
                                                    </div>
                                                    <ul className="ps-3 mb-0" style={{ fontSize: '12px' }}>
                                                        {errors.password.map((error, index) => (
                                                            <li key={index} className="text-danger">
                                                                {error}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ) : (
                                                <div className="text-danger small">{errors.password}</div>
                                            )}
                                        </div>
                                    )}
                                    
                                    {/* Password strength indicator */}
                                    {input.password && !errors.password && (
                                        <div className="mt-2">
                                            <div className="text-success small fw-medium">
                                                <i className="fas fa-check-circle me-1"></i>
                                                {i18n.t("password_strong")}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label text-dark fw-medium mb-1">
                                        <span className="text-danger">*</span> {i18n.t("password_confirmation")}
                                    </label>
                                    <div className="position-relative">
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            name="password_confirmation"
                                            value={input.password_confirmation}
                                            onChange={this.handleInputChange}
                                            className={`form-control ${errors.password_confirmation ? 'is-invalid' : ''}`}
                                            style={{ 
                                                padding: '12px 16px', 
                                                fontSize: '14px', 
                                                borderRadius: '8px',
                                                paddingRight: '45px'
                                            }}
                                            placeholder={i18n.t("password_confirmation")}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                            style={{
                                                border: 'none',
                                                background: 'transparent',
                                                padding: '12px 12px',
                                                zIndex: 5
                                            }}
                                            onClick={this.toggleConfirmPasswordVisibility}
                                        >
                                            <i className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                        </button>
                                    </div>
                                    {errors.password_confirmation && (
                                        <div className="text-danger small mt-1">{errors.password_confirmation}</div>
                                    )}
                                </div>

                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="t_c"
                                            checked={t_c_acept}
                                            onChange={(e) => this.setState({ t_c_acept: e.target.checked })}
                                            style={{ width: '16px', height: '16px' }}
                                        />
                                        <label className="form-check-label ms-2" htmlFor="t_c">
                                            {i18n.t("please_accept")}{" "}
                                            <a href="/terms" target="_new" style={{ color: '#189397', fontSize: '15px' }}>
                                                {i18n.t("terms_conditions")}
                                            </a>
                                        </label>
                                    </div>

                                    {/* <div className="">
                                        <a
                                            className="custom-text3 d-flex"
                                            target="_new"
                                            href={baseUrl + "guide/login.pdf"}
                                        >
                                            <img
                                                height="15.157"
                                                width="15.157"
                                                style={{ marginRight: 5 }}
                                                src="./assets/images/uiw_file-pdf.png"
                                                alt=""
                                            />
                                            {i18n.t("user_guide")}
                                        </a>
                                    </div> */}
                                </div>

                                <div className="col-12 mb-3">
                                    <button
                                        type="submit"
                                        disabled={!t_c_acept || isLoading}
                                        className="btn w-100 text-white fw-medium"
                                        style={{
                                            backgroundColor: '#189397',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            fontSize: '16px',
                                            opacity: !t_c_acept ? 0.6 : 1
                                        }}
                                    >
                                        {isLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                {i18n.t("registering")}
                                            </>
                                        ) : (
                                            i18n.t("signup")
                                        )}
                                    </button>
                                </div>

                                <div className="col-12 text-center mb-4">
                                    <span className="text-muted">
                                        {i18n.t("alreadyhaveaccount")}{" "}
                                        <Link to="/login" style={{ color: '#189397', fontSize: '15px' }}>
                                            {i18n.t("login")}
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                {/* Right Side - Decorative Section */}
                <div
                    className="col-lg-6 d-none d-lg-block position-relative"
                    style={{
                        backgroundImage: `linear-gradient(135deg, rgba(24,147,151,0.5) 0%, rgba(189,197,50,0.5) 100%),url('/assets/images/auth/banner-1.jpeg')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                >
                </div>

                {/* FontAwesome CDN */}
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />
            </div>
        );
    }
}